export const DashboardType = {
  IGetFilterOptionsService: Symbol("IGetFilterOptionsService"),
  IGetChartDataService: Symbol("IGetChartDataService"),
};
